import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ChangePwdGuard } from 'app/shared/guards/change-pwd.guard';

import { unauthGuard } from 'app/shared/guards/unauth.guard';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { ProfileSelectorResolver } from './profile-selector/profile-selector.resolver';
import { ProfileSelectorGuard } from './profile-selector/profile-selector.guard';


const routes: Routes = [
    {
        path: 'login', component: LoginComponent, canActivate: [unauthGuard] },
    {
        path: 'forgot-password', component: ForgotPasswordComponent },

    {
        path: 'welcome', component: ChangePasswordComponent,
        canActivate: [ChangePwdGuard]
    },
    {
        path: 'change-password', component: ChangePasswordComponent,
        canActivate: [ChangePwdGuard]
    },
    {
        path: 'select-profile', 
        loadComponent: () => import('./profile-selector/profile-selector.component').then(mod => mod.ProfileSelectorComponent),
        resolve: {
            'profiles': ProfileSelectorResolver
        },
        canActivate: [ProfileSelectorGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
